<template>
  <el-card id="login">
    <div slot="header">Login</div>
    <el-form :model="user" ref="user" :rules="rules" label-width="100px" label-position="left">
      <el-form-item label="Email" prop="email">
        <el-input v-model="user.email"></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="password">
        <el-input type="password" v-model="user.password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="login()">Login</el-button>
        <el-button @click="reset()">Reset</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<style lang="scss">
#login {
  width: 40%;
  min-width: 300px;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);

  .el-form .el-form-item:last-child {
    margin-bottom: 0;
  }
}
</style>

<script>
export default {
  data () {
    return {
      user: { email: '', password: '' },
      rules: {
        email: [{ required: true, message: 'Please input the email' }],
        password: [{ required: true, message: 'Please input the password' }]
      }
    }
  },
  methods: {
    login () {
      this.$refs.user.validate(valid => {
        if (valid) {
          this.$store.dispatch('auth/login', this.user)
          .then(() => {
            this.$router.push('/')
          })
          .catch(err => {
            let message = err ? err.status + ' ' + err.statusText : 'Unknown error'
            this.$message.error(message)
          })
        }
      })
    },
    reset () {
      this.$refs.user.resetFields()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue